export const ID_FILTER_SEARCH = "search";

export const ID_FILTER_RECHARGE_CUSTOMER = "customer";
export const ID_FILTER_RECHARGE_RFID = "rfid";
export const ID_FILTER_RECHARGE_STATUSES = "statuses";
export const ID_FILTER_RECHARGE_PLACE = "place";
export const ID_FILTER_RECHARGE_STATIONTYPE = "station-type";
export const ID_FILTER_RECHARGE_PUBLIC = "public";
export const ID_FILTER_RECHARGE_PRIVATE = "private";

export const ID_FILTER_REPORT_IMPORTEDDATEFROM = "imported-date-from";
export const ID_FILTER_REPORT_IMPORTEDDATETO = "imported-date-to";
export const ID_FILTER_REPORT_IMPORTEDBY = "imported-by";
export const ID_FILTER_REPORT_STATUSES = "statuses";

export const ID_FILTER_REPORT_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_REPORT_DEALERS = 'dealers';
export const ID_FILTER_RECHARGE_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_RECHARGE_DEALERS = 'dealers';
export const ID_FILTER_CONFIGURATION_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_CONFIGURATION_DEALERS = 'dealers';

export const reportsDefaultValues = {
    creator: "",
    selectedStatuses: [],
    importDateFrom: null,
    importDateTo: null,
    dealers: []
    };
